/*
 * @Author: your name
 * @Date: 2020-04-22 14:11:20
 * @LastEditTime: 2020-06-11 11:36:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\common\components\form-staff-selector\controls\staff-selector-control.ts
 */
import * as tslib_1 from "tslib";
import { userApi } from "@cloudpivot/api";
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
import * as schema from "@cloudpivot/form/src/schema";
import OptionsMap from "@cloudpivot/form/src/typings/form-modals-map";
import userSelectionOptionsMap from "@cloudpivot/form/src/typings/user-selection-map";
// @ts-ignore
import isEqual from 'lodash/isEqual';
const MAPPING_FIELD_OPERATE = "MAPPING_FIELD_OPERATE";
export class StaffSelectorControl extends BaseControl {
    constructor() {
        super(...arguments);
        this.val = [];
        this.staffSelectorOpts = {};
        // setCurrentUser() {
        //     const user = StaffSelectorControl.service.getCurrentUser();
        //     if (user) {
        //         this.ctrl.value = [user];
        //     }
        // }
        // setCurrentUserDept() {
        //     const dept = StaffSelectorControl.service.getCurrentUserDept();
        //     if (dept) {
        //         this.ctrl.value = [dept];
        //     }
        // }
        // initValue() {
        //     if (!this.control.value || !this.control.value.length) {
        //         const type = this.controlOpts.defaultValueType;
        //         if (type === typings.StaffSelectorValueType.Originator) {
        //             this.setCurrentUser();
        //         } else if (type === typings.StaffSelectorValueType.OriginatorDept) {
        //             this.setCurrentUserDept();
        //         }
        //     }
        // }
    }
    get text() {
        return this.val.map(x => x.name).join(";");
    }
    get isMobile() {
        const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        return flag;
    }
    get displayType() {
        if (this.controlOpts.displayType) {
            return this.controlOpts.displayType;
        }
        return schema.DisplayType.Tag;
    }
    get userAttributes() {
        let userAttributes = [...userSelectionOptionsMap.zh_CN.orgAttributes, ...OptionsMap.userAttributes];
        return userAttributes;
    }
    setControl() {
        this.staffSelectorOpts = this.createOptions();
        this.unsubscribe();
        let key = this.controlOpts.orgRoot;
        if (this.controlOpts.orgRootValueType === schema.StaffSelectorValueType.Ref &&
            key &&
            typeof key === "string") {
            key = key.substr(1, key.length - 2);
            let ctrl = "";
            if (this.ctrl.options && this.ctrl.options.inSheet) {
                let rowIndex = this.ctrl.options.rowIndex || 0;
                ctrl = this.findController(key, rowIndex);
            }
            else {
                ctrl = this.findController(key);
            }
            if (ctrl) {
                if (ctrl.value) {
                    this.$set(this.staffSelectorOpts, "rootNode", ctrl.value);
                }
                this.refSubscription = ctrl.valueChange.subscribe((change) => {
                    this.$set(this.staffSelectorOpts, "rootNode", change.value);
                });
            }
        }
        const value = this.ctrl.value;
        let isNew = window.h3form
            ? !!window.h3form.isNew
            : true;
        if (isNew) {
            this.handleValueChange(this.ctrl.value);
        }
        else {
            this.val = value ? value : [];
        }
    }
    handleValueChange(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!value) {
                value === null ? this.val = [] : ''; // 传入人员内容为空时需要初始化视图
                return;
            }
            if (this.control.options.orgRoot && Array.isArray(this.control.options.orgRoot) && this.control.options.orgRoot.length) {
                const params = {
                    unitId: Array.isArray(value) ? value[0].id : value.id,
                    unitType: Array.isArray(value) ? value[0].unitType ? value[0].unitType : value[0].type : value.unitType,
                    departmentIds: this.control.options.orgRoot.map(i => i.id)
                };
                let res = yield userApi.getverifyPersonIsMapping(params);
                if (res.errcode === 0) {
                    if (!res.data) {
                        if (this.isMobile) {
                            this.$h3.toast.hide();
                            this.$h3.toast.show({
                                text: `[${this.control.options.name}] 值不在根节点之内！`
                            });
                        }
                        else {
                            this.$message.destroy();
                            this.$message.error(`[${this.control.options.name}] 值不在根节点之内！`);
                        }
                        this.setValue([]);
                        this.val = [];
                        return;
                    }
                }
                else {
                    this.$message.error(res.errmsg);
                    return;
                }
            }
            if (!this.controlOpts.mappings) {
                if (value) {
                    if (!isEqual(this.val, value)) {
                        this.val = value;
                    }
                }
                else {
                    // 如果当前value为null 并且当前选人控件有值，才将this.value置为空，触发onValueChange事件
                    // 避免进入死循环
                    if (Array.isArray(this.val) && this.val.length > 0) {
                        this.val = [];
                    }
                }
            }
            else {
                if (value) {
                    this.mappingOperate(value);
                }
                else {
                    this.val = [];
                }
            }
        });
    }
    mappingOperate(val) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _tempMappingItem = ["departments", "partTimerDepartment", "manager", "entryDate"];
            let self = this;
            let dirty = false; // val 是否被修改标记
            let userinfo = ['partTimerDepartment', 'mobile', 'email', 'officePhone', 'employeeNo'];
            let mappingList = this.controlOpts.mappings
                .slice(0, -1)
                .split(";")
                .map((val) => val.split(":"));
            for (let _mapping of mappingList) {
                let [mappingItem, mappingKey] = _mapping;
                if (self[MAPPING_FIELD_OPERATE + mappingItem] || userinfo.includes(mappingItem)) {
                    if (mappingItem === "departments" &&
                        (!val[0]["departments"] || val[0]["departments"].length > 1)) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0]);
                    }
                    else if (userinfo.includes(mappingItem) && val[0][mappingItem] === undefined) {
                        dirty = true;
                        //外链不能访问此组织接口，不支持
                        if (!self.isExternal) {
                            yield self[`${MAPPING_FIELD_OPERATE}${'partTimerDepartment'}`](val[0], mappingItem);
                        }
                    }
                    // else if (mappingItem === "partTimerDepartment" && !val[0]["partTimerDepartment"] ) {
                    //   dirty = true;
                    //   //外链不能访问此组织接口，不支持
                    //   if(!self.isExternal){
                    //     await self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0]);
                    //   }
                    // }
                    else if (!val[0][mappingItem] && self[`${MAPPING_FIELD_OPERATE}${mappingItem}`]) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0]);
                    }
                    else if (mappingItem === "mobile" &&
                        (!val[0]["mobile"] || val[0]["mobile"].length > 1)) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0]);
                    }
                }
                else if (~mappingItem.indexOf("LEVEL")) {
                    if (!val[0][mappingItem]) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}OrganizationLevel`](val[0], mappingItem);
                    }
                }
                else if (!_tempMappingItem.includes(mappingItem)) {
                    if (typeof this.val !== typeof val || this.val.length !== val.length) {
                        dirty = true;
                    }
                    else {
                        if (this.val[0][mappingItem] !== val[0][mappingItem]) {
                            dirty = true;
                        }
                    }
                }
                else if (mappingItem.indexOf('entryDate') > -1) {
                    if (val[0][mappingItem] && typeof val[0][mappingItem] === 'string') {
                        val[0][mappingItem] = val[0][mappingItem].replace(/-/g, '/');
                        val[0][mappingItem] = new Date(val[0][mappingItem]);
                        dirty = true;
                    }
                }
            }
            if (dirty) {
                let newVal = [...val];
                this.setValue(newVal);
                if (!isEqual(this.val, val)) {
                    this.val = val;
                }
            }
            else {
                if (!isEqual(this.val, val)) {
                    this.val = val;
                }
            }
            console.log('wtx-------val', this.val);
        });
    }
    // 用户 主部门和兼职部门信息. 两种情况,1. 部门信息都在一个 departments里面,需要区分. 2. 部门信息没有需要额外请求接口
    [MAPPING_FIELD_OPERATE + "departments"](item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (item.departments && item.departments.length > 1) {
                    let _department = [];
                    let _partTimerDepartments = [];
                    for (let dp of item.departments) {
                        if (dp.id !== item.departmentId) {
                            _partTimerDepartments.push(dp);
                        }
                        else {
                            _department.push(dp);
                        }
                    }
                    item["partTimerDepartment"] = _partTimerDepartments;
                    item["departments"] = _department;
                    resolve(item);
                }
                else if (!item.departments) {
                    let { errcode, data, errmsg } = yield userApi.getUserInfo(item.id);
                    if (errcode === 0) {
                        if (data) {
                            let { mainDepartmentName, departmentNames } = data;
                            item["departments"] = mainDepartmentName
                                ? [mainDepartmentName]
                                : [];
                            item["partTimerDepartment"] =
                                departmentNames && departmentNames.length ? departmentNames : [];
                        }
                    }
                    else {
                        this.$message.error(errmsg);
                    }
                    resolve(item);
                }
            }));
        });
    }
    [MAPPING_FIELD_OPERATE + "partTimerDepartment"](item, key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let res = yield userApi.getUserInfo(item.id);
                let { errcode, errmsg } = res;
                let data = res.data;
                if (errcode === 0) {
                    if (data) {
                        let { mainDepartmentName, departmentNames } = data;
                        if (key) {
                            item[key] = data[key] ? data[key] : '';
                        }
                        item["departments"] = mainDepartmentName
                            ? [mainDepartmentName]
                            : [];
                        item["partTimerDepartment"] =
                            departmentNames && departmentNames.length ? departmentNames : [];
                    }
                }
                else {
                    this.$message.error(errmsg);
                }
                resolve(item);
            }));
        });
    }
    // 映射字段-manager-主管信息 获取
    [MAPPING_FIELD_OPERATE + "manager"](item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                StaffSelectorControl.service.getDeptLeader(item.id).then((data) => {
                    if (Array.isArray(data)) {
                        if (data.length) {
                            item["manager"] = data;
                        }
                        else {
                            item["manager"] = [];
                        }
                    }
                    else {
                        item["manager"] = [];
                    }
                    resolve(item);
                });
            });
        });
    }
    // 映射字段-xxx-LEVEL,x -部门信息 获取
    [MAPPING_FIELD_OPERATE + "OrganizationLevel"](item, levelString) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                StaffSelectorControl.service.getOrganizationLevel(item.id).then(data => {
                    if (this.controlOpts) {
                        if (data) {
                            if (data.length > 0) {
                                let level = levelString.split(",")[1];
                                //判断当前返回的组织层级是否与映射的组织层级对应
                                if (level < data.length) {
                                    item[levelString] = [];
                                    item[levelString].push(data[level]);
                                }
                                else {
                                    item[levelString] = [];
                                    item[levelString].push(data[data.length - 1]);
                                }
                            }
                            else {
                                item[levelString] = [];
                            }
                        }
                        else {
                            item[levelString] = [];
                        }
                    }
                    resolve(true);
                });
            });
        });
    }
    // 映射字段 -mobile- 手机号码信息 获取
    [MAPPING_FIELD_OPERATE + "mobile"](item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (item.mobile) {
                    item["mobile"] = item["mobile"];
                    resolve(item);
                }
            }));
        });
    }
    unsubscribe() {
        if (this.refSubscription) {
            this.refSubscription.unsubscribe();
        }
    }
    createOptions() {
        const opts = this.controlOpts;
        const dept = opts.deptVisible;
        const selectOrg = dept === "all" || dept === "org";
        const selectUser = dept === "all" || dept === "user";
        let root;
        if (this.controlOpts.orgRootValueType === schema.StaffSelectorValueType.None) {
            if (opts.orgRoot && typeof opts.orgRoot === "string") {
                try {
                    root = JSON.parse(opts.orgRoot);
                }
                catch (error) { }
            }
            else if (Array.isArray(opts.orgRoot)) {
                root = opts.orgRoot;
            }
        }
        else if (this.controlOpts.orgRootValueType ===
            schema.StaffSelectorValueType.OriginatorDept) {
            root = StaffSelectorControl.service.getCurrentUserDept();
        }
        if (root && !Array.isArray(root)) {
            root = [root];
        }
        let role;
        if (opts.roles && typeof opts.roles === "string") {
            role = JSON.parse(opts.roles);
        }
        let mulpitle = false;
        if (typeof this.controlOpts.multi === "string" && this.controlOpts.multi === 'false') {
            mulpitle = false;
        }
        else {
            mulpitle = Boolean(this.controlOpts.multi);
        }
        return {
            key: this.control.key,
            selectOrg: selectOrg,
            selectUser: selectUser,
            mulpitle,
            rootNode: root,
            role: role,
            showModel: true,
            showSelect: true,
            recursive: this.controlOpts.recursive,
            placeholder: this.placeholder
        };
    }
    destroyed() {
        super.destroyed();
        this.unsubscribe();
    }
}
/**
 * 机构类型
 */
export var OrganizationType;
(function (OrganizationType) {
    /**
     * 部门
     */
    OrganizationType[OrganizationType["Department"] = 1] = "Department";
    /**
     * 角色
     */
    OrganizationType[OrganizationType["Role"] = 2] = "Role";
    /**
     * 用户
     */
    OrganizationType[OrganizationType["User"] = 3] = "User";
})(OrganizationType || (OrganizationType = {}));
/**
 * 用户状态
 */
export var UserStatus;
(function (UserStatus) {
    /**
     * 启用
     */
    UserStatus["Enable"] = "ENABLE";
    /**
     * 禁用
     */
    UserStatus["Disable"] = "DISABLE";
})(UserStatus || (UserStatus = {}));
